import { IconButtonMolecule, IconLabelMolecule } from "..";
import { ContainerAtom, FileInputAtom, HeadingPreviewAtom, IconAtom, LabelAtom } from "../../atoms";
import styles from "./styles.module.scss";

const ACCEPTED_TYPES = ["ZIP", "PDF"];

interface LegacyProps {
  selectedFileName?: string;
  disabled?: boolean;
  error?: string;
  onFileChanged: (file?: File | File[]) => void;
  onBlur: () => void;
  inputRef?: (ref: HTMLButtonElement) => void;
}

export function LegacyFileInputMolecule({
  selectedFileName,
  disabled,
  error,
  onFileChanged,
  onBlur,
  inputRef,
}: Readonly<LegacyProps>) {
  const containerClass = disabled
    ? `${styles.input_container} ${styles["input_container--disabled"]}`
    : styles.input_container;

  let innerContainerClass = styles.input_container__inner;
  if (error) innerContainerClass += ` ${styles["input_container__inner--alert"]}`;

  const isEmpty = !selectedFileName && !disabled;
  const labelText = `${isEmpty ? "Selecteer een" : "Vervangen"} bestand (PDF of ZIP)`;
  const bestandLabel = (
    <LabelAtom id={"selecteer_bestand"} type={"form"} for={"file_input"} italic underlined>
      {labelText}
    </LabelAtom>
  );

  return (
    <div>
      <FileInputAtom
        disabled={disabled}
        accept={ACCEPTED_TYPES}
        onFileChanged={onFileChanged}
        inputRef={inputRef}
        onBlur={onBlur}
      >
        <div className={containerClass}>
          {selectedFileName && (
            <div className={styles.input_container__selectedFileContainer}>
              <HeadingPreviewAtom id="file_input_title">{selectedFileName}</HeadingPreviewAtom>
              {!disabled && bestandLabel}
            </div>
          )}
          {isEmpty && (
            <div className={innerContainerClass}>
              <ContainerAtom>{bestandLabel}</ContainerAtom>
            </div>
          )}
        </div>
      </FileInputAtom>
      {error && <IconLabelMolecule icon="icon-alert-red" label={error} type="alert" />}
    </div>
  );
}

interface FileSelectionAreaProps {
  fileUploadBlocked?: boolean;
  selectedFileName?: string;
  disabled?: boolean;
  error?: string;
  weblocatie?: string;
  onFileChanged: (file?: File | File[]) => void;
  onBlur: () => void;
  onRemoveFile?: () => void;
  inputRef?: (ref: HTMLButtonElement) => void;
}

export function FileSelectionAreaMolecule({
  fileUploadBlocked,
  selectedFileName,
  disabled,
  error,
  weblocatie,
  onFileChanged,
  onBlur,
  onRemoveFile,
  inputRef,
}: Readonly<FileSelectionAreaProps>) {
  const fileUploadDisabled = Boolean(fileUploadBlocked || weblocatie || disabled);
  const showVervangen = !fileUploadDisabled;
  const showVerwijderen = !disabled;
  let innerClassName = styles.input_container__inner;
  if (error) innerClassName += ` ${styles["input_container__inner--alert"]}`;
  const dropZoneClass = fileUploadDisabled ? styles.drop_zone__disabled : innerClassName;

  return (
    <>
      {selectedFileName ? (
        <div className={styles.drop_zone__selected}>
          <IconAtom icon={"icon-check-filled-green"} size={"large"} alt="" />
          <HeadingPreviewAtom id={"file_input_title"}>{selectedFileName}</HeadingPreviewAtom>
          <div className={styles.actions}>
            {showVervangen && (
              <FileInputAtom
                disabled={false}
                accept={ACCEPTED_TYPES}
                onFileChanged={onFileChanged}
                inputRef={inputRef}
                onBlur={onBlur}
              >
                <LabelAtom id={"vervangen_label"} type={"form"} for={"File_input"} underlined>
                  Vervangen
                </LabelAtom>
              </FileInputAtom>
            )}
            {showVerwijderen && (
              <IconButtonMolecule
                id={"file_remove"}
                type={"default"}
                title={"Bestand verwijderen"}
                size={"large"}
                onClick={() => onRemoveFile?.()}
                icon={"icon-remove-blue"}
                removeButton
              />
            )}
          </div>
        </div>
      ) : (
        <FileInputAtom
          disabled={fileUploadDisabled}
          accept={ACCEPTED_TYPES}
          onFileChanged={onFileChanged}
          inputRef={inputRef}
          onBlur={onBlur}
        >
          <div className={dropZoneClass}>
            <div className={styles.drop_zone__content}>
              <IconAtom icon={fileUploadDisabled ? "Map-grey" : "Map"} size={"large"} alt="" />
              <span>
                Sleep het document hierheen of <span className={styles.drop_zone__link}>kies een document</span>
              </span>
            </div>
          </div>
        </FileInputAtom>
      )}
      {error && <IconLabelMolecule icon={"icon-alert-red"} label={error} type={"alert"} />}
      {fileUploadBlocked && !disabled && (
        <IconLabelMolecule
          icon={"icon-alert-blue"}
          label={"Wijzigen van een link naar een bestand is niet mogelijk. Voer hieronder een andere link in."}
          type={"default"}
        />
      )}
      {!fileUploadBlocked && !!weblocatie && !disabled && (
        <IconLabelMolecule
          icon={"icon-alert-blue"}
          label={"Verwijder eerst de link om een document te uploaden"}
          type={"default"}
        />
      )}
    </>
  );
}
